import React, {useReducer} from 'react'
import SelectPhotos from './SelectPhotos'
import ConfirmPhotos from './ConfirmPhotos'
import './index.scss'

function reducer(state, action) {
  switch (action.type) {
    case 'markPhoto': {
      return {
        ...state,
        selectedPhotos: [...state.selectedPhotos, action.photo]
      }
    }
    case 'unmarkPhoto': {
      return {
        ...state,
        selectedPhotos: state.selectedPhotos.filter(photo => photo.id !== action.photo.id)
      }
    }
    case 'updatePhotoComment': {
      return {
        ...state,
        selectedPhotos: state.selectedPhotos.map((photo) => {
          if (photo.id === action.photo.id) {
            return {...photo, comment: action.comment}
          }
          return photo
        })
      }
    }
    case 'setStep': {
      return {...state, step: action.step}
    }
    default: {
      throw new Error(`Unknown action ${action}`)
    }
  }
}

const ProductCorrection = ({match}) => {
  const [state, stateReducer] = useReducer(reducer, {
    selectedPhotos: [],
    step: 'select',
  })

  const setStep = (step) => {
    stateReducer({type: 'setStep', step})
  }

  const StepComponent = state.step === 'confirm' && state.selectedPhotos.length > 0
    ? ConfirmPhotos
    : SelectPhotos

  return (
    <StepComponent
      match={match}
      selectedPhotos={state.selectedPhotos}
      stateReducer={stateReducer}
      setStep={setStep}
    />
  )
}

export default ProductCorrection
